import { useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import SelectCompany from 'components/RCPro/components/form/SelectCompany/SelectCompany'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import Loader from 'components/assets/icons/Loader'
import ResponseMessage from 'components/common/ResponseMessage/ResponseMessage'
import { formParams } from 'constants/inputValidation'
import api from 'helpers/api'
import style from './Company.module.scss'

const RCProCompany = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { nextPageTransition } = useOutletContext()
  const { state, pathname } = useLocation()
  const { company, layout } = state.texts
  const [ loading, setLoading ] = useState(false)
  const [ errorMessage, setErrorMessage ] = useState(false)

  // Initialize form
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    trigger,
    setValue,
    watch
  } = useForm({
    ...formParams,
    values: {
      company: state.company,
      organizationName: state.organizationName,
      companyImmatriculation: state.companyImmatriculation,
      headquarterAddress: state.headquarterAddress,
      headquarterCity: state.headquarterCity,
      headquarterZipcode: state.headquarterZipcode
    },
  })

  const onCompanyChange = datas => {
    setValue('organizationName', datas.organizationName)
    setValue('companyImmatriculation', datas.companyImmatriculation || '')
    setValue('headquarterAddress', datas.headquarterAddress || '')
    setValue('headquarterCity', datas.headquarterCity || '')
    setValue('headquarterZipcode', datas.headquarterZipcode || '')
    trigger()
  }

  const onSubmit = handleSubmit(async data => {
    try{
      setLoading(true)
      setErrorMessage(false)
      const res = await api.get({
        url: `/RCPro/${state.contractType}/${data.companyImmatriculation}`,
        headers: { Authorization: `Bearer ${state.token}` }
      })
      setLoading(false)
      const reasonError = data.headquarterZipcode.match(/^98[78]/) ? 'outside-company'
        : res?.adhesion ? 'registered-company'
        : false
      if (reasonError){
        setTimeout( () => {
          navigate('../oups?reason='+reasonError, { state })
        }, 250)
      } else {
        nextPage({ pathname, state, navigate, data })
      }
      nextPageTransition()
    } catch (err) {
      console.log('Check company adhesion error')
      setLoading(false)
      setErrorMessage(true)
    }
  })

  return (
    <>
      <h1>{company?.title.replace(/{{.+}}/, state.firstname)} 💼</h1>

      {errorMessage && <ResponseMessage className={style.response} label={t('common:form.genericError')} />}

      <FormProvider {...{register, errors}}>
        <form onSubmit={onSubmit}>
          <SelectCompany
            onChange={onCompanyChange}
            value={watch('organizationName')}
          />

          <Button
            label={loading ? <Loader/> : <>{layout?.next} <Arrow /></>}
            onClick={handleSubmit}
            disabled={!isValid || loading || !watch('companyImmatriculation')}
            type={loading ? 'loading' : 'primary'}
          />
        </form>
      </FormProvider>
    </>
  )
}

export default RCProCompany